module.exports = __webpack_public_path__ + "static/img/app_splashscreen_placeholder.71032e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_splashscreen_placeholder.png
// module id = Lyh8
// module chunks = 25